"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSpotWorkerStats = useSpotWorkerStats;
const vue_1 = require("vue");
const orRole_1 = require("../../../model/v1/orRole");
const luxon_1 = require("luxon");
const timeZones_1 = __importDefault(require("../../../common/timeZones"));
function useSpotWorkerStats(shiftStore, workerStore, roleStore) {
    const stats = (0, vue_1.computed)(() => {
        const workers = workerStore.state.employees;
        const column = {};
        for (const shift of Object.values(shiftStore.state.shifts)) {
            if (!workers[shift.userId]?.visibleInShift || shift.userId === 0) {
                continue;
            }
            const dateString = luxon_1.DateTime.fromISO(shift.start, { zone: timeZones_1.default.ASIA_TOKYO }).startOf("day").setZone("UTC").toISO();
            if (!dateString) {
                continue;
            }
            if (!column[dateString]) {
                column[dateString] = {
                    totalCost: 0,
                    laborHours: 0,
                    laborCost: 0,
                    numOfWorkers: 0,
                    transportCost: 0,
                    roleCounts: {},
                    orRoleCounts: {},
                    roleSectionCounts: {},
                    otLaborHours: 0,
                    otLaborCost: 0,
                };
            }
            const laborHours = (new Date(shift.end).getTime() - new Date(shift.start).getTime()) / (1000 * 60 * 60);
            const laborCost = laborHours * shift.wage;
            const day = column[dateString];
            day.laborHours += laborHours;
            day.laborCost += laborCost;
            day.totalCost += laborCost; // transport is always 0
            day.numOfWorkers += 1;
            const role = roleStore.byId(shift.roleId.toString());
            if (!role) {
                continue;
            }
            const roleId = parseInt(role.getId());
            if (!role.isMainRole() && !role.isOrRole()) {
                day.roleCounts[roleId] = (day.roleCounts[roleId] || 0) + 1;
            }
            if (role.isMainRole()) {
                day.orRoleCounts[roleId] = (day.orRoleCounts[roleId] || 0) + 1;
            }
            if (role instanceof orRole_1.OrRole) {
                const mainRoleId = role.getMainRoleId();
                day.orRoleCounts[mainRoleId] = (day.orRoleCounts[mainRoleId] || 0) + 1;
            }
        }
        return { column };
    });
    return stats;
}
